<template>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group">
			<ejs-combobox 
                cssClass="e-outline"
                v-model="filters.processId.value"
                :dataSource='filters.processId.options' 
                :fields='filters.processId.optionsFields' 
                :placeholder="$t('textReports.textFormProcess')" 
            />
		</div>

		<ejs-progressbutton 
            type='submit' 
            cssClass="e-primary" 
            :disabled="disabledButton"
            :spinSettings="spinSettings"
            :duration="50000"
        >
            {{ $t('textBtn.btnSearch') }}
        </ejs-progressbutton>
	</form>
</template>

<script>

import axios from 'axios'
export default {
	name: "reports-form-processes-details",
	props: ['tittle'],
	data(){
		return {
            filters: {
                processId: {
                    value: null,
                    options: [],
                    optionsFields: { text: "nombre", value: 'id'}
                },
            },

			spinSettings: { position: 'Right', width: 20 },
			disabledButton: false,
		}
	},
	methods: {
		initFormProcesses: function() {
            axios.post('/auth/reports/getInitFormProcesses').then(response => {
                this.filters.processId.options = response.data;
			}).catch( ()=>{
                this.filters.processId.options = [];
            });
		},

		validateBeforeSubmit: function() {
			this.disabledButton = true;

			axios.post('/auth/reports/getReportsProcessesDetails', {
				processId: this.filters.processId.value, 
			}).then(response => {
                const filters = this.filters.processId.value 
                    ? 'Proceso - ' + this.filters.processId.options.find( item => item.id == this.filters.processId.value).nombre
                    : '';

				Vue.prototype.$eventHub.$emit('loadDataReports', this.$props.tittle, response.data, filters);
			})
            .catch( ()=>{
                this.$refs.progressBtn.stop();
            })
            .finally( ()=> {
                this.disabledButton = false;
            })
		},
	},
	created: function() {
		this.initFormProcesses();
		this.$eventHub.$on('onResetSwitchTenants', this.initFormProcesses);
	}
}
</script>
